import api from '../api/axios';

const getStatus = () => {
  return api.get('/2fa/status');
};

const setup = () => {
  return api.post('/2fa/setup');
};

const enable = (secret, token) => {
  return api.post('/2fa/enable', { secret, token });
};

const disable = (token) => {
  return api.post('/2fa/disable', { token });
};

const regenerateBackupCodes = (token) => {
  return api.post('/2fa/regenerate-backup-codes', { token });
};

const getTrustedDevices = () => {
  return api.get('/2fa/trusted-devices');
};

const clearTrustedDevices = () => {
  return api.post('/2fa/clear-trusted-devices');
};

const verify = (token) => {
  return api.post('/2fa/verify', { token });
};

const twoFactorServices = {
  getStatus,
  setup,
  enable,
  disable,
  regenerateBackupCodes,
  getTrustedDevices,
  clearTrustedDevices,
  verify,
};

export default twoFactorServices;
